module.exports = __webpack_public_path__ + "img/no_icon.33cda024.svg";